import { Action, createReducer, on } from "@ngrx/store";
import { IComparator } from "../models/comparator.models";
import * as ComparatorsActions from "./comparator.actions";
import { IExecuteSeccess, IResponseMatching } from "../../imports/models/imports.models";
import { IPagination } from "src/app/shared/models/page.model";

export interface ComparatorState {
    comparators: IComparator[];
    metadata: IPagination | null;
    loading: boolean;
    executeLoading: boolean;
    responseMatching: IResponseMatching | null;
    detailsComparator: IExecuteSeccess | null;
  }

  export const initialComparatorState: ComparatorState = {
    comparators: [],
    metadata: null,
    loading: false,
    executeLoading: false,
    responseMatching : null,
    detailsComparator: null
  }

  const featureReducer = createReducer(
    initialComparatorState,
    on(
      ComparatorsActions.GetComparatorsSuccess,
      (state, action) => ({
        ...state,
        comparators: action.Comparators.data,
        metadata: action.Comparators.metadata
      })
    ),
    on(
      ComparatorsActions.ImportComparatorsSuccess,
      (state, action) => ({
        ...state,
        responseMatching: action.responseMatching,
      })
    ),
    on(ComparatorsActions.DetailsComparatorSuccess, (state, action) => ({
      ...state,
      detailsComparator: action.deatailsComparator
    })),
    on(ComparatorsActions.SetComparatorLoader, (state, action) => ({
      ...state,
      loading: action.isLoading
    })),
    on(ComparatorsActions.SetComparatorLoader, (state, action) => ({
      ...state,
      executeLoading: action.isLoading
    }))
  );

  export function comparatorsReducer(state: ComparatorState | undefined, action: Action) {
    return featureReducer(state, action);
  }
